import { HttpError } from '../errors';

export default function pageNotFound({ error }: { error?: Error }): boolean {
  return error instanceof HttpError && error.status === 404;
}
